import { defineComponent as _defineComponent } from 'vue'
import {useCacheStore} from "@/pinia";
import {IToken, ITokenAccount} from "@/shared";
import {PublicKey} from "@solana/web3.js";
import {computed, ref, watch,} from "vue";
import TokenSelectList from "@/components/token/TokenSelectList.vue";

// props
interface IProps {
	value?: any;
}

interface IEmits {
	(e: "input", mint: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterMint',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "input", mint: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	value?: any;
};

// import TokenSearchModal from "@/components/common/TokenSearchModal.vue";


// computed
const getToken = computed<ITokenAccount>(() => {
	// return cacheStore.tokenList[mint.value] ?? token.value;
	return cacheStore.userTokenAccounts[mint.value] ?? token.value;
});

// store
const cacheStore = useCacheStore();

// data
const mint = ref<string>(props.value ?? "");
const showList = ref<boolean>(false)
const token = ref<IToken | null>(null);
// const TokenSearchModalRef = ref<InstanceType<typeof TokenSearchModal> | null>(
// 	null
// );

// computed
const isInvalid = computed<boolean>(() => {
	if (!mint.value) return true;
	return false
});

// methods
async function setToken(t: IToken) {
	console.log("FilterMint:setToken:", t)
	token.value = t;
	mint.value = t.mint || t.address;
	showList.value = false
}

async function toggleList() {
	showList.value = false
}

function openSearch() {
	showList.value = true
	// TokenSearchModalRef.value?.show();
}

// watch
watch(
	() => isInvalid.value,
	() => {
		if (!isInvalid.value) return;

		token.value = null;
	}
);
watch(
	() => mint.value,
	() => {
		emit("input", mint.value);
	}
);

// emits


// expose
expose({isInvalid});

return { __sfc: true,props, getToken, cacheStore, mint, showList, token, isInvalid, setToken, toggleList, openSearch, emit, TokenSelectList }
}

})